import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { LoadingButton } from '@mui/lab';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * The properties for the waiting payment component
 */
interface WaitingPaymentProps {
  /**
   * This will refresh the payment state to see if the payment has been received
   */
  refresh: () => void;
  /**
   * A boolean to communicate whether the outer component is loading. It will get into a
   * loading state if the refresh is called.
   */
  isLoading: boolean;
}

/**
 * This component is shown when payment has been successfully submitted and we're waiting for it on the backend.
 */
const WaitingPayment = (props: WaitingPaymentProps) => (
  <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
    <CircularProgress thickness={5} color="success" size="3em" />
    <Box display="flex" flexDirection="column" alignItems="center">
      <Typography fontWeight="bold" fontSize="1.5em" textAlign="center">
        Payment Submitted Successfully!
      </Typography>
      <Typography color="textSecondary" textAlign="center">
        Once your payment is received, the licenses will be automatically added
        to your organization. Depending on your payment method, this process may
        complete quickly or take a few days.
      </Typography>
    </Box>
    <LoadingButton
      variant="contained"
      loading={props.isLoading}
      onClick={props.refresh}
      endIcon={<RefreshRoundedIcon />}
    >
      Check for Updates
    </LoadingButton>
  </Box>
);

export default WaitingPayment;
